import {
    Button,
    Flex,
    PriorityIcon,
    Separator,
    Title
} from '@priority-software/priority-style-react';
import React from 'react';
import {observer} from 'mobx-react-lite';
import texts from '../../../texts';
import styles from '../../../styles.module.scss';
import FieldTable from '../../FieldsTable';
import {handleAddExpression, handleOpenFieldSelect} from '../../../actions';
import {reportGeneratorsStore} from '../../../stores/ReportGeneratorsStore';
import {chartConfigInfo} from '../../../consts';
import {CheckBoxItem} from '../../CheckBoxItem';
import {IChartConfig} from '../../../types';
import {handleDeleteCompanyCol} from '../../../utils';

const DataPart = observer(() => {
    const {currentReport, onSaveChartInfo} = reportGeneratorsStore?.currentScreen;
    const {isMultiCompany, toggleIsMultiCompany} = currentReport;

    const toggleMultiCompany = () => {
        const prevValue = isMultiCompany;
        toggleIsMultiCompany();
        prevValue && handleDeleteCompanyCol();
        onSaveChartInfo(chartConfigInfo.multiCompany as keyof IChartConfig, isMultiCompany);
    };

    const isExpressionDisabled =
        !currentReport.columns?.length ||
        currentReport.columns.some(col => !col.IsExpression && !col.IsCompany && !col.ColId);

    return (
        <>
            <Title skin="h5" componentClasses={styles.titleWrapper}>
                {texts.chooseData}
            </Title>
            <div className={styles.container}>
                <Flex
                    alignItems="flex-start"
                    justifyContent="flex-start"
                    componentClasses={styles.actionsRow}
                >
                    <Button
                        skin="primary"
                        prefixIcon={PriorityIcon.addSmall}
                        onClick={handleOpenFieldSelect}
                    >
                        {texts.addFieldBtn}
                    </Button>
                    <Button
                        skin="secondary"
                        disabled={isExpressionDisabled}
                        prefixIcon={PriorityIcon.addSmall}
                        onClick={handleAddExpression}
                    >
                        {texts.addExpressBtn}
                    </Button>
                    <Separator align="horizontal" height={30} />
                    <CheckBoxItem
                        title={texts.multiCheckBox}
                        isChecked={isMultiCompany}
                        helpText={texts.multiCompanyHelp}
                        onClick={toggleMultiCompany}
                    />
                </Flex>
                <div className={styles.tableWrapper}>
                    <FieldTable isDataChart />
                </div>
            </div>
        </>
    );
});

export default DataPart;
